import React, { useContext } from 'react';
import UpwardLoaderVector from '../../../ui/loaders/UpwardLoaderVector';
import useInitialValuesHavingModeAsUrlParam from '../util/useInitialValuesHavingModeAsUrlParam';
import withConfigAsContext, { ConfigContext } from './withConfigAsContext';
import { ContainerPageContent } from './withPageContentContainerStyle';

const withEditAddForm = (FormComponent) => {
   const InnerEditAddForm = (props) => {
      const config = useContext(ConfigContext);

      const {
         initialValues,
         isFetching,
         reloadInitialValues,
      } = useInitialValuesHavingModeAsUrlParam(
         config.defaultInitialValues,
         config.settings.external.api.get,
         config.settings.external.api.responseMiddleware,
      );

      const isStateLoading = isFetching && initialValues === undefined;

      return (
         <ContainerPageContent>
            {
               isStateLoading
               && (
                  <div className='w-100 d-flex justify-content-center'>
                     <UpwardLoaderVector/>
                  </div>
               )
            }
            {
               !isStateLoading
               && (
                  <FormComponent
                     {...props}
                     initialValues={initialValues}
                     reloadInitialValues={reloadInitialValues}
                  />
               )
            }
         </ContainerPageContent>
      );
   };

   return InnerEditAddForm;
};

const withHocAgg = (config) => (FormComponent) => withConfigAsContext(
   withEditAddForm(
      FormComponent,
   ),
   config,
);


export default withHocAgg;
